<template>
    <div>
        <el-dialog
                :close-on-click-modal="false"
                title="切图工具"
                :visible.sync="show"
                width="600px"
        >
            <div style="width: 560px; height:350px;margin:0 auto;" v-loading="loading">
                <div class="pb10">
                    <el-radio-group v-model="cutType">
                        <el-radio :label="1">不使用</el-radio>
                        <el-radio :label="2">使用</el-radio>
                    </el-radio-group>
                </div>

                <vueCropper
                        v-if="isHasCrop"
                        ref="cropper"
                        :img="option.img"
                        :outputSize="option.size"
                        :outputType="option.outputType"
                        :info="true"
                        :full="option.full"
                        :canMove="option.canMove"
                        :canMoveBox="option.canMoveBox"
                        :original="option.original"
                        :autoCrop="cutType==2"
                        :autoCropWidth="autoCropWidth"
                        :autoCropHeight="autoCropHeight"
                        :fixedBox="option.fixedBox"
                ></vueCropper>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="finish()" type="primary">确 定</el-button>
                <el-button @click="show = false">取 消</el-button>
            </div>

        </el-dialog>
    </div>
</template>

<script>

    import { VueCropper } from "vue-cropper";

    export default {
        name: "cropperImg",
        components: {VueCropper},
        props:{
            autoCropWidth: {
                type: Number,
                required: true,
                default: 60,
            },
            autoCropHeight: {
                type: Number,
                required: true,
                default: 60,
            }
        },
        data() {

            return {
                isHasCrop:true,
                cutType:1,
                show: false,
                loading: false,
                filename:'',
                option: {
                    img: '',
                    outputSize:1, //剪切后的图片质量（0.1-1）
                    full: false,//输出原图比例截图 props名full
                    outputType: 'png',
                    canMove: true,
                    original: false,
                    canMoveBox: true,
                    autoCrop: true,
                    autoCropWidth: 150,
                    autoCropHeight: 150,
                    fixedBox: true
                },
            }
        },
        computed: {

        },
        methods: {
            closeDialog(){
                this.show=false;
            },
            //上传图片（点击上传按钮）
            finish() {
                this.$refs.cropper.getCropData((data) => {

                    this.$emit('uploadHttp',this.base64ToFile(data,this.filename||'aaa.png'));
                })
            },
            base64ToFile(Base64, filename) {
                let arr = Base64.split(',');
                let mime = arr[0].match(/:(.*?);/)[1];
                let bstr = atob(arr[1]);
                let n = bstr.length;
                let u8arr = new Uint8Array(n);
                while(n--){
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new File([u8arr], filename, {type:mime});
            },

            uploadImg(file) {
                this.filename=file.name;
                this.show=true;
                this.$nextTick(()=>{
                    let reader = new FileReader();
                    reader.onload =(e) => {
                        let data;
                        if (typeof e.target.result === 'object') {
                            // 把Array Buffer转化为blob 如果是base64不需要
                            data = window.URL.createObjectURL(new Blob([e.target.result]))
                        }
                        else {
                            data = e.target.result
                        }
                        this.option.img = data
                    }
                    reader.readAsDataURL(file);

                })
            }
        },
        watch: {
            show(val){
                if(!val){
                    this.cutType=1;
                }
            },
            cutType(){
                this.isHasCrop=false;
                this.$nextTick(()=>{
                    this.isHasCrop=true;
                })
            }

        },
        filters: {}
    };
</script>

<style scoped lang="less">
    /deep/.el-dialog__body{
        padding-top: 0!important;
    }

</style>
